import _ from 'lodash'
import React from 'react'

const Text = props =>
  _.trim(props.text || '').split("\n").map( (line, idx) =>
    <React.Fragment key={`line-${_.kebabCase(line)}-${idx}`}>
      { idx !== 0 && <br /> }{line}
    </React.Fragment>
  )

export default Text



// WEBPACK FOOTER //
// ./src/components/Text.js